import Api from '@plone/volto/helpers/Api/Api';

const api = new Api();

function getErrorMessage(err) {
  return (
    err?.response?.body?.error ||
    err?.response?.body?.message ||
    err?.message ||
    'Request failed'
  );
}

function rethrowWithResponse(err) {
  const error = new Error(getErrorMessage(err));
  error.response = err?.response;
  throw error;
}

export async function listShortUrls() {
  try {
    const data = await api.get('/@shlink-short-urls');
    return data?.shortUrls?.data || [];
  } catch (err) {
    rethrowWithResponse(err);
  }
}

export async function createShortUrl(payload) {
  try {
    return await api.post('/@shlink-short-urls', { data: payload });
  } catch (err) {
    rethrowWithResponse(err);
  }
}

export async function deleteShortUrl(shortCode) {
  try {
    return await api.del(`/@shlink-short-urls/${encodeURIComponent(shortCode)}`);
  } catch (err) {
    rethrowWithResponse(err);
  }
}
